import { useI18n } from "../i18n/localization";

/** Original white Whisperz mark (public/brand/whisperz-mark.svg) — for dark backgrounds only. */
export const BRAND_MARK_SRC = "/brand/whisperz-mark.svg";

// Header brand: mark + "Whisperz Secured Conferencing Systems". Flexible and allowed to wrap so
// the long name never crowds the language/navigation controls on narrow phones. The name is the
// same in every locale and kept LTR-isolated inside the Hebrew (RTL) layout.
export function BrandTitle() {
  const { t } = useI18n();
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 10, flex: "1 1 180px", minWidth: 0 }}>
      <img src={BRAND_MARK_SRC} alt="" aria-hidden width={28} height={28} style={{ flex: "0 0 auto", display: "block" }} />
      <strong dir="ltr" style={{ unicodeBidi: "isolate", lineHeight: 1.25, overflowWrap: "anywhere", minWidth: 0 }}>
        {t.app.brand}
      </strong>
    </span>
  );
}

/** Compact mark on a navy chip — for light headers (embedded launch context bar). */
export function BrandChip() {
  const { t } = useI18n();
  return (
    <span title={t.app.brand} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 26, height: 26, borderRadius: 6, background: "#14305f", flex: "0 0 auto" }}>
      <img src={BRAND_MARK_SRC} alt={t.app.brand} width={18} height={18} style={{ display: "block" }} />
    </span>
  );
}
